import React from 'react';
import { Typography } from 'radiance-ui';

import { REQUEST_BRAND } from 'jsx/utils/brand';
import CONFIG from 'jsx/constants/config';

import { EXTERNAL_URLS } from './urlConstants';
import Layout from './layout';
import {
  PageContainer,
  NavigationContainer,
  ButtonRow,
  LinkButton,
} from './style';

const DevLanding = () => (
  <Layout>
    <PageContainer>
      <h1>Welcome to {REQUEST_BRAND.displayName}’s Developer Center</h1>
      <NavigationContainer>
        <ButtonRow>
          <LinkButton href="/admin" disabled={CONFIG.isAgencyApp}>
            Admin
          </LinkButton>
          <LinkButton href="/auth">Auth</LinkButton>
        </ButtonRow>
        <ButtonRow>
          <LinkButton href="/magic">Magic</LinkButton>
          <LinkButton href={EXTERNAL_URLS.notionProductEngMain}>
            Notion
          </LinkButton>
        </ButtonRow>
      </NavigationContainer>
      <Typography.Caption>
        To view and develop any marketing or static pages, see our Gatsby repo
        setup <a href={EXTERNAL_URLS.notionGatsbySetup}>here</a>.
      </Typography.Caption>
    </PageContainer>
  </Layout>
);

export default DevLanding;
